








import Vue from "vue";
import { Component } from "vue-property-decorator";
import ApiFactory from "../../api/ApiFactory";
import { OccupationDto } from "@/api/ClientPortalApiClient";

@Component({})
export default class CbxOccupation extends Vue {
  private types: OccupationDto[] | null = [];
  public selectedType = new OccupationDto();

  public created() {
    this.getAvailableTypes();
  }

  public setSelected(type: OccupationDto | undefined) {
    if (type) {
      this.selectedType = type;
    }
  }

  public setSelectedName(name: string) {
    if (this.types) {
      this.types.forEach(element => {
        if (element.name === name) {
          this.selectedType = element;
          return;
        }
      });
    }
  }

  public typeSelected(type: OccupationDto) {
    this.$emit("occupationSelected", type);
  }

  private getAvailableTypes() {
    const api = ApiFactory.CreateDataClient();
    api
      .occupation_IndexAll()
      .then(result => {
        if (result) {
          this.types = result;
        } else {
          this.types = [];
        }
      })
      .catch(error => {
        console.log(error);
        this.types = [];
      });
  }
}
